<div class="modal-body wrapper-modal position-relative w-100 d-flex flex-column">
    <i matTooltip="Cerrar" class="fas fa-times fa-2xl close-icon-actions" (click)="onClose()"></i>

    <section class="px-2 px-md-5">
        <h3 class="text-bold text-center my-4 text-balance">
            El servicio {{data?.cargo?.consecutive}} requiere correcciones
        </h3>
        <h5 class="text-center mb-4 text-balance font-weight-normal">
            {{ sectionsWithErrors }}. Deben ser solucionados para poder continuar con el flujo.
        </h5>

        <div class="validation-cards-container">
            <div class="validation-card" *ngFor="let item of sectionsArray">
                <div class="validation-card__header">
                    <h5 class="text-bold mb-0">{{item?.section?.name}}</h5>
                </div>

                <div class="validation-card__content">
                    <div class="validation-status" [ngClass]="{
                        'validation-status--valid': item?.section?.checkValid?.isValid,
                        'validation-status--invalid': !item?.section?.checkValid?.isValid
                    }">
                        <i class="fas" [ngClass]="{
                            'fa-check-circle': item?.section?.checkValid?.isValid,
                            'fa-exclamation-circle': !item?.section?.checkValid?.isValid
                        }"></i>
                        <span class="validation-message">
                            {{item?.section?.checkValid?.isValid
                            ? 'Sección válida'
                            : item?.section?.checkValid?.error}}
                        </span>
                    </div>

                    <div class="validation-card__actions"
                        *ngIf="!item?.section?.checkValid?.isValid && canEditSection(item?.section)">
                        <button mat-raised-button color="accent" type="button" class="edit-section-btn"
                            (click)="onEditSection(item.key)">
                            <i class="fas fa-edit"></i>
                            <span>Editar sección</span>
                        </button>
                    </div>

                    <div class="validation-card__restrictions"
                        *ngIf="!item?.section?.checkValid?.isValid && !canEditSection(item?.section)">
                        <div class="restriction-message">
                            <i class="fas fa-lock"></i>
                            <span class="restriction-failed">{{getRestrictionFailed(item?.section)}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <div class="button-container mt-4">
        <button mat-raised-button class="primary-secondary button-width-auto" color="secondary-dark"
            (click)="onClose()">
            <span class="text-bold">Cerrar</span>
        </button>
    </div>
</div>